// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabletLayout_root__2qrcW {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.TabletLayout_root__2qrcW .TabletLayout_content__IERhn {
  flex: 1 1;
  background-color: #f2f2f2;
}`, "",{"version":3,"sources":["webpack://./src/components/templates/TabletLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AACF;AACE;EACE,SAAA;EACA,yBAAA;AACJ","sourcesContent":[".root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n\r\n  .content {\r\n    flex: 1;\r\n    background-color: #f2f2f2;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TabletLayout_root__2qrcW`,
	"content": `TabletLayout_content__IERhn`
};
export default ___CSS_LOADER_EXPORT___;
